<template>
    <div class="upload-pictures-wrapper" ref="uploadPicturesWrapper" :class="{'is-dialog': isDialog}">
    <div class="picture-count">
      <div class="Nav">
        <div class="trees-coadd">
          <div class="scollhide">
            <div class="trees">
              <el-tree ref="treeRef" :data="treeData2" :props="defaultProps" node-key="attachmentCategoryId"
                :highlight-current="true" :expand-on-click-node="false" :current-node-key="treeId"
               @nodeClick="appendBtn">
                <template #default="{ node, data }">
                  <div class="custom-tree-node">
                    <div>
                      <span>{{ node.label }}</span>
                    </div>
                    <span>
                      <el-dropdown @command="(command) => clickMenu(data, String(command))">
                        <!--                       <span class="add MoreFilled" />-->
                        <!--                         <span class="add el-icon-more" />-->
                        <el-icon>
                          <MoreFilled />
                        </el-icon>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item command="1">新增分类</el-dropdown-item>
                            <el-dropdown-item v-if="data.attachmentCategoryId" command="2">编辑分类</el-dropdown-item>
                            <el-dropdown-item v-if="data.attachmentCategoryId" command="3">删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </span>
                  </div>
                </template>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
        <div v-loading="loading" class="conter">
            <div class="flex pb-20 items-start">
                <div class="flex">
              <!-- 对齐 EB：素材管理页不展示「使用选中图片」 -->
              <el-button v-if="params !== picturePagePath" size="small" type="primary"
               @click="checkPics(true)">使用选中图片</el-button>
              <el-button size="small" class="upload-demo" type="primary" @click="uploadModal">上传图片</el-button>
              <!--<el-button v-if="isPage" type="success" size="small" @click.stop="onAdd(0)">添加分类</el-button>-->
              <el-button type="danger" size="small" :disabled="!ids.length"
               @click.stop="deletePicList('图片')">删除图片</el-button>
              <el-cascader v-model="pids" placeholder="图片移动至" class="w-150 ml-14"
                :options="treeData2" :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'attachmentCategoryName',
                  value: 'attachmentCategoryId'
               }" clearable size="small" @visibleChange="handleSelClick"></el-cascader>
            </div>
              <el-input v-model="tableData.attachmentName" placeholder="请输入图片名称搜索" class="ml-14 w-160 pic-search-input" size="small"
               @keyup.enter="getFileList(1)" @change="() => getFileList(1)">
                <template #suffix>
                  <el-icon class="el-input__icon" style="cursor: pointer;" @click="getFileList(1)">
                    <Search />
                  </el-icon>
                </template>
              </el-input>
              <el-radio-group v-if="isPage" v-model="lietStyle" size="small" class="view-style-radio" @change="radioChange">
                <el-radio-button value="list">
                  <i class="iconfont icongongge"></i>
                </el-radio-button>
                <el-radio-button value="table">
                  <i class="iconfont iconliebiao"></i>
                </el-radio-button>
              </el-radio-group>
          </div>
            <div class="pictrueList-wrapper relative">
                <div class="pictrueList-body absolute">
                  <div class="pictrueList acea-row" :class="{ 'is-modal': !isPage }">
                    <div v-if="lietStyle == 'list'"  :class="{ 'margin-inline-auto': isShowPic }">
                      <div v-show="isShowPic" class="imagesNo">
                        <i class="el-icon-picture" style="font-size: 60px;color: rgb(219, 219, 219);" />
                        <span class="imagesNo_sp">图片库为空</span>
                      </div>
                      <div class="conters" :class="{gridSmall : isDialog}" v-if="pictrueList.list.length">
                        <div v-for="(item, index) in pictrueList.list" :key="item.attachmentId" class="gridPic">
                          <p class="number" v-if="item.num > 0">
                            <el-badge class="item" :value="item.num">
                              <a href="#" class="demo-badge"></a>
                            </el-badge>
                          </p>
                          <div class="img" :class="item.isSelect ? 'on' : ''" @click="changImage(item, index, pictrueList.list)">
                            <img :src="item.src || item.attachmentSrc" />
                          </div>
                          <div class="operate-item" @mouseenter="enterLeave(item)" @mouseleave="enterLeave(item)">
                            <p v-if="!item.isEdit">
                              {{ item.attachmentName }}
                            </p>
                            <el-input v-else v-model="item.attachmentName" size="small" link @blur="handleEdit(item)" />
                            <div class="operate-item operate-height">
                              <span v-if="item.isShowEdit" class="operate mr10" @click="deletePic(item)">删除</span>
                              <span v-if="item.isShowEdit" class="operate mr10" @click="item.isEdit = !item.isEdit">重命名</span>
                              <span v-if="item.isShowEdit" class="operate" @click="lookImg(item)">查看</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <el-table v-if="lietStyle == 'table'" ref="tableRef" v-loading="loading" size="small"
                      :data="pictrueList.list" highlight-row :row-key="getRowKey" class="ones" no-data-text="暂无数据"
                     no-filtered-data-text="暂无筛选结果" @selectionChange="handleSelectRow">
                      <el-table-column type="selection" width="60" :reserve-selection="true"> </el-table-column>
                      <el-table-column label="图片名称" min-width="190">
                        <template #default="scope">
                          <div class="df-aic">
                            <div v-viewer class="tabBox_img mr10">
                              <img :src="scope.row.src || scope.row.attachmentSrc" alt="" />
                            </div>
                            <span v-if="!scope.row.isEdit" class="line2 real-name">{{ scope.row.attachmentName
                              }}</span>
                            <el-input v-else v-model="scope.row.attachmentName"  class="w-90-p111" size="small" link
                             @blur="handleEdit(scope.row)" />
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="上传时间" min-width="100">
                        <template #default="scope">
                          <span>{{ scope.row.createTime }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" fixed="right" width="170">
                        <template #default="scope">
                          <el-button type="primary" size="small" @click="deletePic(scope.row)">删除</el-button>
                          <el-button type="primary" size="small" @click="scope.row.isEdit = !scope.row.isEdit">{{
                            scope.row.isEdit
                              ? "确定" : "重命名" }}</el-button>
                          <el-button type="primary" size="small" @click="lookImg(scope.row)">查看</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
            </div>
          <div class="footer-page ">
              <div class="flex-y-center">
                  <el-checkbox v-if="lietStyle === 'list'" v-model="allSelect" @change="selectAll">全选</el-checkbox>
                  <span class="fs-12 text--w111-999 pl-8">已选 {{ checkPicList.length }} 个</span>
              </div>
              <div></div>
            <el-pagination class="pagination-wrapper"  background :pager-count="isDialog ? 5 : 7" v-model:page-size="tableData.limit" v-model:current-page="tableData.page"
              layout="total, prev, pager, next ,jumper" :total="pictrueList.total" @sizeChange="handleSizeChange"
             @currentChange="pageChange" />
          </div>
        </div>
    </div>
    <uploadImg ref="uploadRef" :isPage="isPage" :isIframe="isIframe" :categoryId="treeId" :categoryList="treeData"
     @uploadSuccess="uploadSuccess"></uploadImg>
    <div v-show="false" v-viewer="{ movable: false }" class="images">
      <img v-for="src in pictrueList.list" :key="src.attachmentId" :src="src.attachmentSrc" />
    </div>
  </div>
</template>

<script setup lang="ts">
//3.4
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import { ref, reactive, computed, watch, onMounted, nextTick, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { MoreFilled, Search } from '@element-plus/icons-vue';
import { roterPre } from '@/setting';
import {
  formatLstApi,
  attachmentCreateApi,
  attachmentUpdateApi,
  picNameEditApi,
  attachmentDeleteApi,
  attachmentListApi,
  picDeleteApi,
  categoryApi
} from "@/api/system";
import { getToken } from "@/utils/auth";
import SettingMer from "@/libs/settingMer";
import UploadImg from '@/components/uploadImg/index.vue';
import { useFormCreateHelper } from '@/composables/useFormCreateHelper';

const { proxy } = getCurrentInstance()!
/** 对齐 EB：素材管理页路径，用于隐藏「使用选中图片」 */
const picturePagePath = `${roterPre}/config/picture`
// 定义接口
interface Props {
  isMore?: string
  setModel?: string
  isIframe?: boolean
  isPage?: boolean
  pageLimit?: number
}

interface TableData {
  page: number
  limit: number
  attachmentCategoryId: number
  order: string
  attachmentName: string
}

interface PictrueList {
  list: any[]
  total: number
}

interface TreeData {
  attachmentCategoryName: string
  attachmentCategoryId: number
  children?: TreeData[]
}

// 定义 props
const props = withDefaults(defineProps<Props>(), {
  isMore: '1',
  isIframe: false,
  isPage: false,
  pageLimit: 18
});

// 定义 emits
const emit = defineEmits<{
  getImage: [images: string[]]
 getPic: [payload: { attDir: string[] }]
}>();

// 响应式数据
const fileType= ref( 'img');
const loading = ref(false);
const params = ref('');
const pids = ref('');
const treeId = ref(0);
const sleOptions = reactive({
  attachmentCategoryName: '',
  attachmentCategoryId: ''
});
const list = ref<any[]>([]);
const filterText = ref('');
const treeData = ref<TreeData[]>([]);
const treeData2 = ref<TreeData[]>([]);
const defaultProps = reactive({
  children: 'children',
  label: 'attachmentCategoryName'
});
const classifyId = ref(0);
const myHeaders = reactive({ 'Authorization': 'Bearer ' + getToken() });
const tableData = reactive<TableData>({
  page: 1,
  limit: props.pageLimit,
  attachmentCategoryId: 0,
  order: '',
  attachmentName: '',
    attachmentType: 0
});
const pictrueList = reactive<PictrueList>({
  list: [],
  total: 0
});
const isShowPic = ref(false);
const checkPicList = ref<string[]>([]);
const ids = ref<number[]>([]);
const checkedMore = ref<string[]>([]);
const checkedAll = ref<string[]>([]);
const selectItem = ref<any[]>([]);
const editId = ref(''); // 记录id
const editName = ref(''); // 记录保存前名字
const lietStyle = ref('list');
const isDialog = ref(false);
const allSelect = ref(false);

// refs
const treeRef = ref();
const tableRef = ref();
const uploadRef = ref<{ uploadModal: boolean }>();

// 计算属性
const fileUrl = computed(() => {
  return SettingMer.https + `/upload/image/${tableData.attachmentCategoryId}/file`;
});

// 监听器
watch(filterText, (val) => {
  treeRef.value?.filter(val);
});

// 方法
const radioChange = () => {
  initData();
};

const initData = (keepGlobal = false) => {

    if (!keepGlobal) {
        checkPicList.value = [];
        selectItem.value = [];
        ids.value = [];
    }
    allSelect.value = false;
  if (lietStyle.value == 'table') tableRef.value?.clearSelection();
  pictrueList.list.forEach((el,i) => {
    el.isSelect = false;
    el.num = 0;
  });
};


const getRowKey = (row: any) => {
  return row.attachmentId;
};


//  选中某一行
const handleSelectRow = (selection: any[]) => {
    // 获取当前页所有数据的ID集合
    const currentPageIds = new Set(pictrueList.list.map(item => item.attachmentId));
    // 获取当前页选中的ID集合
    const selectedIds = new Set(selection.map(item => item.attachmentId));

    // 遍历当前页的数据，更新全局选中状态
    currentPageIds.forEach(id => {
        const index = ids.value.indexOf(id);
        const item = pictrueList.list.find(i => i.attachmentId === id);

        if (selectedIds.has(id)) {
            // 当前页选中的行，添加到全局选中
            if (index === -1) {
                ids.value.push(id);
                if (item) {
                    checkPicList.value.push(item.attachmentSrc);
                }
            }
        } else {
            // 当前页取消选中的行，从全局选中移除
            if (index !== -1) {
                ids.value.splice(index, 1);
                if (item) {
                    // 移除对应的图片URL
                    const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
                    if (srcIndex !== -1) {
                        checkPicList.value.splice(srcIndex, 1);
                    }
                }
            }
        }
    });

    // 更新全选复选框状态
    allSelect.value = selection.length > 0 && selection.length === pictrueList.list.length;
};


// 对象数组去重
const unique = (arr: any[]) => {
  let result = arr.reduce((acc, curr) => {
    const x = acc.find((item: any) => item.attachmentId === curr.attachmentId);
    if (!x) {
      return acc.concat([curr]);
    } else {
      return acc;
    }
  }, []);
  return result;
};

const lookImg = (item: any) => {
  const imageUrl = item.attachmentSrc;
  const viewer = (document.querySelector('.images') as any)?.$viewer;
  if (viewer) {
    viewer.show();
    nextTick(() => {
      let i = pictrueList.list.findIndex(
        (e: any) => e.attachmentSrc === item.attachmentSrc
      );
      viewer.update().view(i);
    });
  }
};

// 搜索分类
const filterNode = (value: string, data: any) => {
  if (!value) return true;
  return data.attachmentCategoryName.indexOf(value) !== -1;
};

// 所有分类
const getList = () => {
  const data = {
    attachmentCategoryName: '全部图片',
    attachmentCategoryId: 0
  };
  formatLstApi()
    .then((res: any) => {
      treeData.value = res.data;
      treeData.value.unshift(data);
      treeData2.value = [...treeData.value];
    })
    .catch((res: any) => {
      ElMessage.error(res.message);
    });
};

// 编辑图片名称
const handleEdit = (item: any) => {
  if (!item.attachmentName.trim()) {
    ElMessage.warning('请先输入图片名称');
    return;
  }
  picNameEditApi(item.attachmentId, {
    attachmentName: item.attachmentName
  })
    .then((res: any) => {
      item.isEdit = false;
      ElMessage.success(res.message);
    })
    .catch((error: any) => {
      ElMessage.error(error.message);
    });
};

// 添加分类
const onAdd = (id: number) => {
  const config: any = {};
  if (Number(id) > 0) config.formData = { pid: id };
  if (proxy) {
    (proxy as any).$modalForm(() => attachmentCreateApi(), config).then(({ message }: any) => getList())
  }
};

// 编辑
const onEdit = (id: number) => {
  if (proxy) {
    (proxy as any).$modalForm(() => attachmentUpdateApi(id)).then(() => getList())
  }
};

// 删除
const handleDelete = (id: number) => {
  (proxy as any).$modalSure('删除该条分类').then(() => {
    attachmentDeleteApi(id)
      .then(({ message }: any) => {
        ElMessage.success(message);
        getList();
          // 删除分类后，确保显示全部分类的图片内容
          treeId.value = 0;
          tableData.attachmentCategoryId= 0;
          getFileList(1);
      })
      .catch(({ message }: any) => {
        ElMessage.error(message);
      });
  });
};

// 点击树
const appendBtn = (data: any) => {
  treeId.value = data.attachmentCategoryId;
  tableData.attachmentCategoryId = data.attachmentCategoryId;
  selectItem.value = [];
  checkPicList.value = [];
  tableData.page = 1;
  getFileList(1);
};

const handleNodeClick = (data: any) => {
  treeId.value = tableData.attachmentCategoryId;
  tableData.attachmentCategoryId = data.attachmentCategoryId;
  selectItem.value = [];
  checkPicList.value = [];
  getFileList(1);
};

// 点击上传
const uploadModal = () => {
  if (uploadRef.value) {
    uploadRef.value.uploadModal = true;
  }
};

const uploadSuccess = () => {
  tableData.page = 1;
  getFileList(1);
};

const enterMouse = (item: any) => {
  item.realName = !item.realName;
};

const enterLeave = (item: any) => {
  item.isShowEdit = !item.isShowEdit;
};

// 点击菜单
const clickMenu = (data: any, name: string) => {
  if (name == '1') {
    onAdd(data.attachmentCategoryId);
  } else if (name == '2') {
    onEdit(data.attachmentCategoryId);
  } else if (name == '3') {
    handleDelete(data.attachmentCategoryId);
  }
};

// 上传成功
const handleSuccess = (response: any) => {
  if (response.status === 200) {
    ElMessage.success('上传成功');
    getFileList(1);
  } else {
    ElMessage.error(response.message);
  }
};

// 文件列表
const getFileList = (num?: number) => {
  loading.value = true;
  tableData.page = num ? num : tableData.page;
  attachmentListApi(tableData)
    .then(async (res: any) => {
      res.data.list.forEach((el: any) => {
        el.isSelect = false;
        el.isEdit = false;
        el.isShowEdit = false;
        el.realName = false;
        el.num = 0;
      });
      pictrueList.list = res.data.list;
        // 如果当前页没有数据且不是第一页，则回退到上一页
        if (pictrueList.list.length === 0 && tableData.page > 1) {
            tableData.page--;
            getFileList("");
            return;
        }
      if (pictrueList.list.length) {
        isShowPic.value = false;
      } else {
        isShowPic.value = true;
      }
      if (
        route &&
        route.query.field &&
        route.query.field !== 'dialog'
      ) {
        const fieldValue = getFieldValue(route.query.field as string);
        checkedMore.value = Array.isArray(fieldValue) ? fieldValue : [];
      }

      pictrueList.total = res.data.count;
      loading.value = false;

        // 恢复选中状态
        nextTick(() => {
            if (lietStyle.value === 'table' && tableRef.value && ids.value.length > 0) {
                // 表格模式恢复选中
                pictrueList.list.forEach(item => {
                    if (ids.value.includes(item.attachmentId)) {
                        tableRef.value.toggleRowSelection(item, true);
                    }
                });
            } else if (lietStyle.value === 'list' && ids.value.length > 0) {
                // 列表模式恢复选中
                pictrueList.list.forEach(item => {
                    if (ids.value.includes(item.attachmentId)) {
                        item.isSelect = true;
                        const exists = selectItem.value.some(i => i.attachmentId === item.attachmentId);
                        if (!exists) {
                            selectItem.value.push(item);
                        }
                    }
                });
                // 重新计算序号
                pictrueList.list.forEach((el, i) => {
                    if (el.isSelect) {
                        const idx = selectItem.value.findIndex(el2 => el.attachmentId == el2.attachmentId);
                        el.num = idx + 1;
                    } else {
                        el.num = 0;
                    }
                });
                // 更新全选状态
                const shouldAllSelect = pictrueList.list.length > 0 &&
                    pictrueList.list.every(item => item.isSelect);
                allSelect.value = shouldAllSelect;
            } else {
                allSelect.value = false;
            }
        });
    })
    .catch((res: any) => {
      ElMessage.error(res.message);
      loading.value = false;
    });
};


const pageChange = (page: number) => {
    tableData.page = page;
    // 只重置当前页的视觉选中状态，不清空全局选中的数据
    if (lietStyle.value === 'list') {
        pictrueList.list.forEach(item => {
            item.isSelect = false;
            item.num = 0;
        });
    }
    if (lietStyle.value === 'table' && tableRef.value) {
        tableRef.value.clearSelection();
    }
    allSelect.value = false;
    getFileList();
}

const handleSizeChange = (val: number) => {
  tableData.limit = val;
  getFileList(1);
};


// 选中图片 - 修改 allSelect 更新部分
const changImage = (item: any, index: number, row: any[]) => {
    if (!item.isSelect) {
        // 选中
        item.isSelect = true;
        selectItem.value.push(item);
        checkPicList.value.push(item.attachmentSrc);
        ids.value.push(item.attachmentId);
    } else {
        // 取消选中
        item.isSelect = false;
        const idIndex = ids.value.indexOf(item.attachmentId);
        if (idIndex > -1) ids.value.splice(idIndex, 1);

        const selectIndex = selectItem.value.findIndex(o => o.attachmentId == item.attachmentId);
        if (selectIndex > -1) selectItem.value.splice(selectIndex, 1);

        const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
        if (srcIndex > -1) checkPicList.value.splice(srcIndex, 1);
    }

    // 更新序号
    pictrueList.list.forEach((el, i) => {
        if (el.isSelect) {
            const idx = selectItem.value.findIndex(el2 => el.attachmentId == el2.attachmentId);
            el.num = idx + 1;
        } else {
            el.num = 0;
        }
    });

    // 更新全选状态 - 直接计算当前页是否全选
    const currentPageSelectedCount = pictrueList.list.filter(el => el.isSelect).length;
    allSelect.value = currentPageSelectedCount === pictrueList.list.length && pictrueList.list.length > 0;
}



// 全选功能 - 切换全选和取消全选
const selectAll = () => {
    // 表格模式下使用 Element UI 表格的全选 API
    if (lietStyle.value === 'table' && tableRef.value) {
        tableRef.value.toggleAllSelection();
        return;
    }

    // 列表模式下的全选逻辑
    // 判断当前页是否已全选
    const currentPageSelectedCount = pictrueList.list.filter(item => item.isSelect).length;
    const isAllSelectedOnCurrentPage = currentPageSelectedCount === pictrueList.list.length && pictrueList.list.length > 0;

    if (isAllSelectedOnCurrentPage) {
        // 取消全选：只清除当前页的选中状态
        pictrueList.list.forEach((item) => {
            if (item.isSelect) {
                item.isSelect = false;
                item.num = 0;
                // 从全局选中中移除
                const idIndex = ids.value.indexOf(item.attachmentId);
                if (idIndex > -1) ids.value.splice(idIndex, 1);

                const selectIndex = selectItem.value.findIndex(i => i.attachmentId === item.attachmentId);
                if (selectIndex > -1) selectItem.value.splice(selectIndex, 1);

                const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
                if (srcIndex > -1) checkPicList.value.splice(srcIndex, 1);
            }
        });
        // 手动设置 allSelect 为 false
        allSelect.value = false;
    } else {
        // 全选：选中当前页所有未选中的项
        pictrueList.list.forEach((item) => {
            if (!item.isSelect) {
                item.isSelect = true;
                selectItem.value.push(item);
                checkPicList.value.push(item.attachmentSrc);
                ids.value.push(item.attachmentId);
            }
        });
        // 手动设置 allSelect 为 true
        allSelect.value = true;

        // 更新序号
        pictrueList.list.forEach((el, i) => {
            if (el.isSelect) {
                const idx = selectItem.value.findIndex(el2 => el.attachmentId == el2.attachmentId);
                el.num = idx + 1;
            }
        });
    }
};

// 点击使用选中图片
const checkPics = (isButton?: boolean) => {
  if (checkPicList.value.length) {
    if (route) {
      if (route.query.type === '1') {
        if (checkPicList.value.length > 1)
          return ElMessage.warning('最多只能选一张图片');

        const field = route.query.field as string;
        setFieldValue(field, checkPicList.value[0] as any);

        if (isButton) {
          closeField(field);
        }
      }
      if (route.query.type === '2') {
        checkedAll.value = [...checkedMore.value, ...checkPicList.value];
        const field = route.query.field as string;
        setFieldValue(field, Array.from(new Set(checkedAll.value)) as any);
        closeField(field);
      }
      if (route.query.field === 'dialog') {
        // 构建图片HTML字符串
        const imageHtml = checkPicList.value
          .map(imageUrl => `<img src="${imageUrl}" alt="图片" style="max-width: 100%; height: auto;">`)
          .join('');

        // 安全地插入到富文本编辑器
        try {
          if (window.nowEditor && window.nowEditor.editor) {
            window.nowEditor.editor.execCommand('insertHtml', imageHtml);
            if (window.nowEditor.dialog && typeof window.nowEditor.dialog.close === 'function') {
              window.nowEditor.dialog.close(true);
            }
          } else {
            console.warn('富文本编辑器未初始化或不可用');
            ElMessage.warning('编辑器未初始化，无法插入图片');
          }
        } catch (error) {
          console.error('插入图片到编辑器失败:', error);
          ElMessage.error('插入图片失败，请重试');
        }
      }
      emit("getPic", {
        attDir: checkPicList.value
      });
      emit('getImage', checkPicList.value);
    } else {
      if (props.isMore === '1' && checkPicList.value.length > 1) {
        return ElMessage.warning('最多只能选一张图片');
      }
      emit("getPic", {
        attDir: checkPicList.value
      });
      emit('getImage', checkPicList.value);
    }
  } else {
    ElMessage.warning('请先选择图片');
  }
};

// 单个删除
const deletePic = (item: any) => {
  ids.value = [item.attachmentId];
  deletePicList();
};


// 删除图片
const deletePicList = (tit?: string) => {
    const idsData = {
        ids: ids.value
    };
    ElMessageBox.confirm('确定删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        picDeleteApi(idsData)
            .then(({ message }) => {
                ElMessage.success(message);
                // 记录当前删除的ID列表
                const deletedIds = [...ids.value];
                // 从全局选中中移除已删除的项
                deletedIds.forEach(id => {
                    const index = ids.value.indexOf(id);
                    if (index !== -1) {
                        ids.value.splice(index, 1);
                    }
                    const item = pictrueList.list.find(i => i.attachmentId === id);
                    if (item) {
                        const srcIndex = checkPicList.value.indexOf(item.attachmentSrc);
                        if (srcIndex !== -1) {
                            checkPicList.value.splice(srcIndex, 1);
                        }
                    }
                });
                getFileList("");
                spliceDeleteList();
                // 不要调用 initData，因为这会清除所有选中状态
            })
            .catch(({ message }) => {
                ElMessage.error(message);
            });
    }).catch(() => {
        ElMessage({
            type: 'info',
            message: '已取消'
        });
    });
}

// 去除选中数组中删除掉的元素
const spliceDeleteList = () => {
  selectItem.value.map((el, i) => {
    ids.value.filter((el2, j) => {
      if (el.attachmentId == el2) {
        selectItem.value.splice(i, 1);
      }
    });
  });
};

// 移动分类点击
const handleSelClick = (status: boolean) => {
  if (!status) {
    getMove();
  } else {
    if (!ids.value.toString()) {
      ElMessage.warning('请先选择图片');
      return;
    }
  }
};

const getMove = () => {
  let data = {
    pid: pids.value,
    images: ids.value.toString()
  };
  if (!data.images) return;
  if (pids.value === '') {
    ElMessage.warning('请选择分类');
    return;
  }
  categoryApi(ids.value, pids.value)
    .then(async (res: any) => {
      ElMessage.success(res.message);
      pids.value = '';
      initData(); // 移动后清空所有选中；keepGlobal=true 会留下 ids，刷新后「全部图片」里又被画成选中
      getFileList(1);
    })
    .catch((res: any) => {
      pids.value = '';
        initData(true);
      ElMessage.error(res.message);
    });
};

// 路由
const route = useRoute();

// FormCreate 辅助对象
const { setFieldValue, closeField, getCurrentField, onOk, getFieldValue } = useFormCreateHelper();

// 生命周期
onMounted(() => {
  params.value = route && route.path ? route.path : '';
  if (route && route.query.field === 'dialog') {
    // import('../../../public/UEditor/dialogs/internal')
  }
  // console.log('onMounted params', params.value);
  getList();//分类
  getFileList(1);//图片
  if ((route && route.query.field) || !route)
    isDialog.value = true;
  if (route && route.query.field === 'dialog') {
    isDialog.value = true;
    // 注册确定按钮回调
    onOk(() => {
      checkPics();
    });
  }
});
</script>

<style scoped lang="scss">
.pb-20{
    padding-bottom: 20px;
}
/* Element Plus 边框靠 box-shadow，勿给 el-input 定死 height，否则上下边被裁断 */
.pic-search-input {
  flex-shrink: 0;
}
/* 对齐 EB：视图切换靠右；留 1px 避免父级 overflow:hidden 裁掉右边线 */
.view-style-radio {
  margin-left: auto;
  flex-shrink: 0;
  padding: 1px;
  box-sizing: content-box;
}
.Nav{
    width: 220px;
    border-right: 1px solid #eee;
    height: 100%;
    overflow: auto;
}
.picture-count{
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
}

.nav-wrapper {
  width: 220px;
  height: 100%;
  position: relative;
}

.abs-full {
  position: absolute;
  inset: 0;
  overflow: auto;
}


.flex-end {
  display: flex;
  box-pack: end;
  justify-content: flex-end;
}

.selectTreeClass {
  background: #d5e8fc;
}

:deep(.ones th) {
  background: #F0F5FF;
}

.treeBox {
  width: 100%;
  height: 100%;
}


.tabBox_img {
  display: flex;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.real-name {
  flex: 1;
}

.df-aic {
  display: flex;
  align-items: center;
}

.tree_w {
  padding: 20px 30px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  padding-right: 17px;
  height: 36px;
  color: rgba(0, 0, 0, 0.6);

  .add {
    font-size: 10px;
    color: rgba(0, 0, 0, 0.6);
  }
}

.is-current .custom-tree-node,
.is-current .MoreFilled {
  color: var(--prev-color-primary);
}

:deep(.el-tree-node) {
  position: relative;
}

:deep(.is-current::after) {
  content: "";
  display: block;
  width: 2px;
  height: 40px;
  background: var(--prev-color-primary);
  position: absolute;
  right: 0;
  top: 0;
}

:deep(.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node_Content) {
  background: rgba(67, 127, 253, 0.04);
}

.el-ic {
  display: none;

  i,
  span {
    font-size: 18px;
    font-weight: 600;
  }

  .svg-icon {
    color: var(--prev-color-primary);
  }
}

.el-tree-node__expand-icon {
  color: var(--prev-color-primary);
}

:deep(.el-tree-node__content) {
  height: 40px;
}

.el-tree-node__content:hover .el-ic {
  color: var(--prev-color-primary) !important;
  display: inline-block;
}

.el-dialog__body {
  .upload-container .image-preview .image-preview-wrapper img {
    height: 100px;
  }

  .el-dialog .el-collapse-item__wrap {
    padding-top: 0px;
  }

  .spatial_img {
    .el-collapse-item__wrap {
      margin-bottom: 0;
      padding-top: 0px;
    }
  }

  .upload-container .image-preview .image-preview-wrapper {
    width: 120px;
  }

  .upload-container .image-preview .image-preview-action {
    line-height: 100px;
    height: 100px;
  }
}

.trees-coadd {
  width: 100%;
  border-radius: 4px;
  // overflow: hidden;
  position: relative;

  .scollhide {
    overflow-x: hidden;
    overflow-y: scroll;
    box-sizing: border-box;

    .trees {
      width: 100%;
    }
  }

  .scollhide::-webkit-scrollbar {
    display: none;
  }
}

.conters {
  display: flex;
  flex-wrap: wrap;
}

.pictrueList-wrapper {
    flex: 1;
    .pictrueList-body {
        inset: 0;
        overflow: auto;
    }
}
.is-modal .gridPic {
    width: 100px;

    .img {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgb(248, 248, 248);
        padding: 2px;
        img {
            max-width: 96px;
            max-height: 96px;
            width: auto;
            height: auto;
            object-fit: contain;
        }
        .operate-height {
            bottom: -8px;
        }
    }
}

.gridPic {
  position: relative;
  width: 146px;
  cursor: pointer;
  margin: 10px 5px 0 5px !important;

  .img {
    width: 146px;
    height: 146px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(248, 248, 248);
    padding: 3px;
    box-sizing: border-box;
    overflow: hidden;

    img {
      max-width: 140px;
      max-height: 140px;
      width: auto;
      height: auto;
      object-fit: contain;
    }
  }

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 20px;
      line-height: 20px;

    font-size: 12px;
    color: #515a6d;
    text-align: center;
  }

  .number {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
      height: 33px;

  }

  .demo-badge {
    width: 42px;
    height: 42px;
    background: transparent;
    border-radius: 6px;
    display: inline-block;
  }
}

.gridPic :deep(.el-badge__content) {
  position: absolute;
  transform: translateX(50%);
  top: 0;
  right: 14px;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
}

.conter-content {
  flex: 1;
  overflow: auto;
}

.conter {
    flex: 1;
    min-height: 540px;
    height: 100%;
    margin-left: 20px;
    display: flex;
    flex-direction: column;

  .pictrueList {
      width: 100%;
      height: 100%;
    // height: calc(100vh - 260px);
    overflow-y: auto;

    el-image {
      width: 100%;
      border: 2px solid #fff;
    }

    .on {
      border: 2px solid #5fb878;
    }
  }

  .footer-page {
      display: flex;
      justify-content: space-between;
      align-items: center;
    margin-top: 14px;
  }

  .el-image {
    width: 110px;
    height: 110px;
    cursor: pointer;
  }

  .imagesNo {
      height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .imagesNo_sp {
      font-size: 13px;
      color: #dbdbdb;
      line-height: 3;
    }
  }
}

.operate-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.operate-height {
  height: 16px;
}

.operate {
  color: var(--prev-color-primary);
  font-size: 12px;
  white-space: nowrap;
}

.w-90-p111{
    width: 90%;
}
.flex-end{
    justify-content: flex-end !important;
}

.margin-inline-auto {
    margin-inline: auto;
}

.upload-pictures-wrapper {
    height: 100%;

    &.is-dialog {
        height: 550px;
    }
}

.pagination-wrapper {
    margin-top: 0 !important;

    :deep( .el-pagination__total) {
        margin-right: 3px;
    }

    :deep( .el-pagination__jump) {
        margin-left: 3px;
    }
}
</style>
